import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=ed76e752&scoped=true&"
import script from "./ProjectHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed76e752",
  null
  
)

export default component.exports